import React, { useEffect, useRef, useState } from 'react'
import { notification, Row, Col, Drawer, Table } from 'antd'
import { useDispatch } from 'react-redux'
import { addNoteFxn } from '../../../unizHome/actions'
import { TableComp } from 'sz-react-utils-lite'
import { getNotesFxn } from '../action'
import TextArea from 'antd/es/input/TextArea'
import renderHTML from 'react-render-html'
import { longDisplayDate } from '../../../components/_utils/appUtils'

const AddNote = (props) => {
  const dispatch = useDispatch()
  const {
    onClose,
    refreshList,
    visible,
    enquiryId
  } = props
  let [note, setNote] = useState('')
  let [noteList, setNoteList] = useState([])
  const tableRef = useRef()
  useEffect(() => {
    apiRequest()
  }, [enquiryId])
  const apiRequest = async () => {
    let respData = await dispatch(getNotesFxn({ enquiryId }))
    if (respData && respData._id) {
      setNoteList(respData.notes && respData.notes.length ? respData.notes.reverse() : [])
    }
  }
  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      render: (val, record, index) => {
        return index + 1
      }
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      render: (val, record) => {
        let { addedBy, date } = record
        return (
          <div className={'enquiry_note_text'}>
            {val}
            <br />
            <div className={'alignRight colorPrimary font12'}>
              <div>Added By : {addedBy.name}, ({longDisplayDate(date)})</div>
            </div>
          </div>
        )
      }
    }
  ]

  const handleSubmit = async () => {
    if (!note) {
      notification.warning({ message: 'Please enter note.' })
      return
    }
    let userData = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : null
    const valData = {
      enquiryId,
      note: note,
      addedBy: {
        _id: userData._id,
        name: userData.name,
        email: userData.email
      }
    }
    let data = await dispatch(addNoteFxn(valData))
    if (data.success) {
      setNote('')
      refreshList()
      apiRequest()
    }
  }


  return (
    <React.Fragment>
      <Drawer visible={visible}
              title={`Add Note`}
              width={'50%'}
              closable={true}
              maskClosable={true}
              onClose={onClose}>
        <div className='card unizportal'>
          <div className='inner-form'>
            <Row gutter={24}>
              <Col>
                <TextArea
                  value={note}
                  placeholder={'Enter note'}
                  onChange={({ target }) => {
                    setNote(target.value)
                  }} />
              </Col>
            </Row>
            <a className={'btn bgTheme roundNew mt-2'} onClick={handleSubmit}>Submit</a>
          </div>
        </div>
        <div className='card unizportal'>
          <Table
            bordered={true}
            columns={columns}
            dataSource={noteList}
            ref={tableRef}
            pagination={false}
          />
        </div>

      </Drawer>
    </React.Fragment>
  )
}


export default AddNote
